"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const Wizard_1 = require("../../../../../Wizard");
const use_form_api_1 = __importDefault(require("@data-driven-forms/react-form-renderer/use-form-api"));
const WizardStep = ({ activeStepIndex, maxStepIndex, title, description, fields, stepsInfo, onNextButtonClick, onPreviousButtonClick, submitButtonText, }) => {
    const [showError, setShowError] = react_1.useState(false);
    const formOptions = use_form_api_1.default();
    const content = react_1.useMemo(() => {
        const editabledFields = fields.map((item) => (Object.assign(Object.assign({}, item), { showError })));
        return formOptions.renderForm(editabledFields);
    }, [fields, showError, formOptions]);
    react_1.useEffect(() => {
        setShowError(false); // When steps change
    }, [activeStepIndex]);
    const handleNextButtonClick = () => {
        const state = formOptions.getState();
        setShowError(true);
        if (!(state.invalid || state.validating || state.submitting)) {
            onNextButtonClick();
        }
    };
    return (react_1.default.createElement(Wizard_1.WizardInner, { step: {
            title,
            description,
            content,
        }, activeStepIndex: activeStepIndex, maxStepIndex: maxStepIndex, stepsInfo: stepsInfo, stepCount: stepsInfo.length, submitButtonText: submitButtonText, onNextButtonClick: handleNextButtonClick, onPreviousButtonClick: onPreviousButtonClick, onCancelButtonClick: formOptions.onCancel, onSubmitButtonClick: (event) => {
            event.preventDefault();
            formOptions.handleSubmit();
        }, disableStepNavigation: true }));
};
exports.default = WizardStep;
//# sourceMappingURL=index.js.map